/**
 * Checks if the session is currently active. Passes in the settings 
 * and the store and returns a bool.
 * @param {object} settings
 * @param {object} store 
 */
export const isActiveSession = (settings, store) => {
    let state = store.getState();
    let history = state[settings.stateLocations.History.Base][settings.stateLocations.History.Messages] || [];
    return history.length > 0;
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/util/session.js